import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'react-icons-kit';
import { ic_code } from 'react-icons-kit/md/ic_code';
import { HoverTooltip } from 'shared/components/ui/HoverTooltip';
import { buttonClasses } from 'styles/tailwindClassnames';

// Switches a builder between its visual view and the raw code view with a
// single button: a code icon while building, the word "Builder" while in
// code. Shared by the webhook schema and transformation builders.
export const CodeBuilderToggle = ({
  isCodeMode,
  onToggle,
  dataTestId,
}: {
  isCodeMode: boolean;
  onToggle: () => void;
  dataTestId?: string;
}) => {
  const { t } = useTranslation();

  if (isCodeMode) {
    return (
      <button
        type="button"
        data-testid={dataTestId}
        onClick={() => onToggle()}
        className={buttonClasses.outlineXs}
      >
        {t('Builder')}
      </button>
    );
  }

  return (
    // Portaled: the builders sit in overflow-hidden panels.
    <HoverTooltip content={t('Code')} position="top" focusable={false} portal>
      <button
        type="button"
        data-testid={dataTestId}
        aria-label={t('Code')}
        onClick={() => onToggle()}
        className="flex items-center text-greyscale-5 hover:text-ui-text-primary-text"
      >
        <Icon icon={ic_code} size={20} />
      </button>
    </HoverTooltip>
  );
};
